var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 23,
    viewBox: "0 0 33 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1956_4482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4993 3.63071C18.5729 3.63071 20.5594 4.4587 22.0248 5.93543C23.4888 7.41067 24.3132 9.41315 24.3132 11.5019C24.3132 15.8488 20.8151 19.37 16.4993 19.37C14.4278 19.3723 12.4406 18.5428 10.9737 17.0653C9.50971 15.5901 8.68605 13.5884 8.68605 11.5019C8.68605 9.4154 9.50897 7.41067 10.9737 5.93543C12.4406 4.45945 14.4286 3.62921 16.5 3.63071H16.4993ZM16.4993 0C6.05557 0 0 8.62265 0 11.5019C0 14.3811 6.05557 23.0007 16.4993 23.0007C26.9429 23.0007 33 14.3803 33 11.5019C33 8.62341 26.9467 0 16.4993 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3495 11.5017C21.3495 13.8552 19.6918 15.8794 17.3967 16.3264C15.1017 16.7741 12.8141 15.5186 11.9412 13.3354C11.0691 11.1507 11.8577 8.65021 13.8211 7.37373C15.7837 6.09424 18.3724 6.39949 19.99 8.09897L16.4695 11.5032H21.3495V11.5017Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1956_4482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeb);
export default __webpack_public_path__ + "static/media/eyeb.74545363f2b3bbfcde5cf5c4e88322f1.svg";
export { ForwardRef as ReactComponent };